<template>
  <div class="live-cast">
    <!-- <button class="btn" @click="stopCast">중지</button> -->
    <video
      id="liveCast"
      ref="liveCastVideo"
      class="video mx-auto d-block"
      autoplay
      controls>
    </video>
    <media-status :media="media"></media-status>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MediaStatus from './MediaStatus'
import alert from '@/mixins/alert'
import Remon from '@remotemonster/sdk'
import { remonDefaultConfig as rtcDefaultConfig } from '@/config'
import l from '@/vendor/logger'

let remon

export default {
  name: 'CastLive',

  mixins: [
    alert
  ],

  created () {
    window.onbeforeunload = this.stopCast
  },

  mounted () {
    this.castLive()
  },

  beforeDestroy () {
    window.onbeforeunload = null
    if (remon) { this.stopCast() }
  },

  data () {
    return {
      media: {}
    }
  },

  computed: {
    ...mapGetters('user', [
      'isSignIn'
    ]),
    ...mapState([
      'rid'
    ]),
    ...mapState('room', [
      'room',
      'type'
    ]),
    ...mapState('media', [
      'constraints',
      'maxBandwidth',
      'codec',
      'simulcast'
    ])
  },

  watch: {
    type (newType, oldType) {
      if (newType !== 'CAST') {
        this.stopCast()
      }
    }
  },

  methods: {
    stopCast (event) {
      l.d('CastLive/stopCast', remon)
      if (remon) {
        remon.close()
        remon = null
        l.d('CastLive/stopCast/remon_removed', remon)
      }
      // NOTE: room automaticaly unbind during view page destoryed
      this.$router.push({ name: 'home' })
    },
    castLive () {
      const vm = this

      const rtcConfig = {
        ...rtcDefaultConfig,
        rtc: {
          ...rtcDefaultConfig.rtc,
          simulcast: vm.simulcast
        },
        view: { local: '#liveCast' },
        media: {
          ...vm.constraints,
          video: {
            ...vm.constraints.video,
            maxBandwidth: vm.maxBandwidth,
            codec: vm.codec
          },
          sendonly: true
        }
      }

      // NOTE: browser choose constraints automaticaly. Don't need delete deviceId : null
      rtcConfig.media.video.height.exact || delete rtcConfig.media.video.height
      rtcConfig.media.video.width.exact || delete rtcConfig.media.video.width
      rtcConfig.media.video.frameRate.exact || delete rtcConfig.media.video.frameRate
      rtcConfig.media.video.codec || delete rtcConfig.media.video.codec
      rtcConfig.media.video.simulcast || delete rtcConfig.media.video.simulcast
      rtcConfig.media.video.maxBandwidth || delete rtcConfig.media.video.maxBandwidth

      const rtcListener = {
        onCreate (chId) {
          if (!vm.rid) {
            vm.stopCast()
            return
          }
          l.d('CastLive/remon/onCreate', chId)
          vm.$store.dispatch('room/createRoom', chId)
          vm.$store.dispatch('media/saveSettings')
          vm.media = vm.$refs.liveCastVideo.srcObject
        },
        onClose () {
          vm.stopCast()
        },
        onError (err) {
          vm.showAlert({
            error: { name: err, message: '' }
          })
          vm.stopCast()
        },
        onStateChange (state) {
          l.d('CastLive/remon/onStateChange', state)
        }
      }

      l.d('CastLive/createLive/rtcConfig', rtcConfig)
      remon = new Remon({ config: rtcConfig, listener: rtcListener })
      remon.createCast(this.room.name)
    }
  },

  components: {
    MediaStatus
  }
}
</script>

<style scoped>

.live-cast {
  & .video {
    background-color: black;
    width: 640px;
    height: 480px;
  }
}
</style>
